import { render, staticRenderFns } from "./AsideMenu.vue?vue&type=template&id=29b03010&scoped=true"
import script from "./AsideMenu.vue?vue&type=script&lang=ts"
export * from "./AsideMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b03010",
  null
  
)

export default component.exports